import { UpdateCoverPageConfigurationInput } from '@/types/schema';

import { BundleSaveDescriptor } from '../presentationSave.types';
import { createFlatConfigDescriptor } from './flatConfigDescriptor';

/** Writes the cover bundle configuration. Page content is diffed separately. */
export const coverSlideBundleDescriptor: BundleSaveDescriptor =
  createFlatConfigDescriptor({
    field: 'coverSlideBundleConfiguration',
    read: (bundle) => bundle.coverSlideBundleConfiguration,
    diff: (previous, next) => {
      const update: UpdateCoverPageConfigurationInput = {};

      if (previous.customText !== next.customText) {
        if (next.customText) {
          update.customText = next.customText;
        } else {
          update.clearCustomText = true;
        }
      }

      return Object.keys(update).length > 0 ? update : null;
    },
    toPayload: (id, update) => ({
      updateCoverPageConfiguration: { id, update },
    }),
  });
